import {
  FloatingFormItem,
  InputDecimal,
  InputText,
} from '@/components/_common';
import { PurchaseItemsFormValues } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import {
  Col,
  Divider,
  Form,
  FormInstance,
  Row,
  Select,
  Typography,
} from 'antd';
import { useIntl } from 'react-intl';

interface Props {
  form: FormInstance<PurchaseItemsFormValues>;
}

const PisForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const { Title } = Typography;

  const { purchase } = useReleasePurchaseFormContext();

  return (
    <Form form={form}>
      <Row gutter={[12, 12]}>
        <Col span={24} lg={24}>
          <Title level={3} style={{ padding: 0 }}>
            {intl.formatMessage({
              id: 'purchases.details.itemsPurchase.pis.taxRegime.title',
            })}
          </Title>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'cstPis']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.pis.taxRegime.cstPis',
            })}
          >
            <InputText
              onlyNumber
              maxLength={2}
              disabled={purchase?.boschMigration}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} lg={4} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'calcPercentPis']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis',
            })}
            initialValue={1}
          >
            <Select
              style={{ width: '100' }}
              options={[
                {
                  value: 1,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis.percentage',
                  }),
                },
                {
                  value: 0,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis.value',
                  }),
                },
              ]}
              disabled={purchase?.boschMigration}
            />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'quotaPis']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.pis.taxRegime.quotaPis',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'basePis']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.pis.taxRegime.basePis',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueUnityPis']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.pis.taxRegime.valueUnityPis',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valuePis']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.pis.taxRegime.valuePis',
            })}
            initialValue={0}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Divider style={{ margin: 0 }} />

        <Col span={24} lg={24}>
          <Title level={3} style={{ padding: 0 }}>
            {intl.formatMessage({
              id: 'purchases.details.itemsPurchase.pisSt.taxRegime.title',
            })}
          </Title>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'calcPercentPisSt']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.pisSt.taxRegime.calcPercentPisSt',
            })}
            initialValue={1}
          >
            <Select
              style={{ width: '100' }}
              options={[
                {
                  value: 1,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis.percentage',
                  }),
                },
                {
                  value: 0,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis.value',
                  }),
                },
              ]}
              disabled={purchase?.boschMigration}
            />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'quotaPisSt']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.pisST.taxRegime.quotaPisSt',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueUnityPisSt']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.pisST.taxRegime.valueUnityPisSt',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'basePisSt']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.pisST.taxRegime.basePisSt',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valuePisSt']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.pisST.taxRegime.valuePisSt',
            })}
            initialValue={0}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default PisForm;
